var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"case"},[_c('banner',{attrs:{"img":_vm.sty,"title":"精典案例"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }